import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'http://1256171973-gcm6czc2cb.ap-guangzhou.tencentscf.com',
  timeout: 10000,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

export default {
  upload(formData) {
    return apiClient.post('/upload', formData);
  }
};